// Packages
import React from "react"
import { Link } from "gatsby"
import { BLOCKS, INLINES } from "@contentful/rich-text-types"
import { colors } from "@abmg-components"
import { renderRichText } from "gatsby-source-contentful/rich-text"

// Components
import ArticleToolTip from "@components/knowledge-center/contentful-components/article-tooltip"

// Categories
export const CategoryBadgeHoverColor = category => {
  if (category === "real estate round-up") {
    return colors["thistle-purple-2"].hex
  }
  if (category === "finances") {
    return colors["palm-green-3"].hex
  }
  if (category === "mortgages") {
    return colors["atlantic-blue-4"].hex
  }
  if (category === "homeownership") {
    return colors["sunset-orange-3"].hex
  }
}

export const CategoryColorLightFinder = category => {
  if (category === "real estate round-up") {
    return colors["thistle-purple-1"].hex
  }
  if (category === "homeownership") {
    return colors["sunset-orange-2"].hex
  }
  if (category === "mortgages") {
    return colors["atlantic-blue-2"].hex
  }

  if (category === "finances") {
    return colors["palm-green-2"].hex
  } else return null
}

export const CategoryColorDarkFinder = category => {
  if (category === "real estate round-up") {
    return colors["thistle-purple-6"].hex
  }
  if (category === "homeownership") {
    return colors["sunset-orange-6"].hex
  }
  if (category === "mortgages") {
    return colors["atlantic-blue-6"].hex
  }

  if (category === "finances") {
    return colors["palm-green-5"].hex
  } else return null
}

export const CategoryTitleString = category => {
  if (category === "real estate round-up") {
    return "REAL ESTATE ROUND-UP"
  }
  if (category === "homeownership") {
    return "HOUSE TO HOME"
  }
  if (category === "mortgages") {
    return "MORTGAGE MATTERS"
  }
  if (category === "finances") {
    return "FINANCIAL WELLNESS"
  } else return null
}

// Rich Text
export const richTextOptions = props => {
  return {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (node, children) => {
        if (
          node.content.every(
            node => node.nodeType === "text" && node.value == "",
          )
        )
          return null
        return <p>{children}</p>
      },
      [BLOCKS.TABLE]: (node, children) => {
        const thRow = node.content.find(
          node =>
            node.nodeType === "table-row" &&
            node.content?.every(node => node.nodeType === "table-header-cell"),
        )
        const tbodyRows = node.content.filter(
          node =>
            node.nodeType === "table-row" &&
            node.content?.every(node => node.nodeType !== "table-header-cell"),
        )

        return (
          <table
            className={`[--columns:var(--table-columns,var(--numColumns))] @container/table min-w-[var(--table-width,724px)] w-full [&_tr]:grid [&_tr]:grid-cols-[minmax(100px,169px)_repeat(calc(var(--columns)-1),minmax(260px,1fr))] [&_tr]:justify-between  [&_tr_>_*]:[padding-inline:16px] `}
            style={{
              "--numColumns": thRow.content.length,
            }}
          >
            {thRow && (
              <thead>
                {renderRichText(
                  { raw: JSON.stringify(thRow) },
                  richTextOptions(props),
                )}
              </thead>
            )}
            <tbody>
              {tbodyRows.map(tbodyRow => {
                return renderRichText(
                  { raw: JSON.stringify(tbodyRow) },
                  richTextOptions(props),
                )
              })}
            </tbody>
          </table>
        )
      },
      [BLOCKS.TABLE_ROW]: (node, children) => {
        const isHeaderRow = node.content.every(
          node => node.nodeType === "table-header-cell",
        )
        return (
          <tr
            className={`  ${
              isHeaderRow
                ? "bg-[#264564] [&_*]:font-bold [&_*]:text-grey-1 "
                : `[&_a]:text-pacific-blue  min-h-[148px] [&:nth-child(even)]:bg-atlantic-blue-2 [&:nth-child(odd)]:bg-grey-1  
                  }`
            }`}
          >
            {children}
          </tr>
        )
      },
      [BLOCKS.TABLE_HEADER_CELL]: (node, children) => {
        return (
          <th
            className={`[&_*]:!leading-[32px] [&_*]:!text-[20px] [&_*]:text-balance [&_*]:!tracking-[.6px] flex items-center justify-center [padding-block:12px]`}
          >
            {children}
          </th>
        )
      },
      [BLOCKS.TABLE_CELL]: (node, children) => {
        return (
          <td
            className={`flex flex-col h-full justify-center  [padding-block:22px] [&_*]:!leading-[28px] [&_*]:!text-[18px] [&_*]:!-tracking-[.36px]`}
          >
            {children}
          </td>
        )
      },
      [INLINES.EMBEDDED_ENTRY]: node => {
        if (node.data.target.__typename === "ContentfulArticleTooltip") {
          return (
            <ArticleToolTip
              category={props.category}
              fields={node.data.target}
              setTooltipOverlay={props.setTooltipOverlay}
            />
          )
        } else if (
          node.data.target.__typename === "ContentfulArticleInternalLink"
        ) {
          let slug
          // If internal link is to a KC article
          if (
            !node.data.target.category ||
            node.data.target.category === "KC"
          ) {
            slug = props.bankerData
              ? `/${props.bankerData?.slug}/knowledge-center/${node.data.target.link}`
              : `/knowledge-center/${node.data.target.link}`
          }
          // If internal link is not to a KC article
          else {
            slug = `/${node.data.target.link}`
          }

          return <Link to={slug}>{node.data.target.linkText}</Link>
        }
      },
      [INLINES.HYPERLINK]: node => {
        return (
          <a href={node.data.uri} target="_blank" rel="noreferrer">
            {node.content[0].value}
          </a>
        )
      },
    },
  }
}
